// extracted by mini-css-extract-plugin
export default {"root":"IconPound_root__i28vw"};